<template>
  <div class="container">
    <div class="tableBackground">
      <div class="tableBox">
         <div style="font-size: 22px;height:250px;margin-top:125px;">美钥二维码产品目前为线下销售模式，如果需要，请联系电话13001001954，或者邮箱liqingfengzzu@163.com</div>
      </div>
    </div>
    <div class="term">
      <span style="font-size:20px;color:#38dba4">会员须知：</span>
      <ul>
        <li><strong>会员有效期：</strong>用户购买会员的套餐为会员权限的起始日，购买套餐后以自然日计算会员周期</li>
        <li><strong>升级会员：</strong>用户升级套餐后，现有套餐的余额将会转换为高级版的套餐天数。如目前为基础版，剩余100天，在升级为高级版后，基础版剩余的时长将会转换为高级版的61天，用户将共获得426天的高级版套餐</li>
        <li><strong>降级会员：</strong>用户无法从更高等级的套餐降为低等级的套餐，可在当前套餐结束后重新购买</li>
      </ul>
    </div>
    <br>
    <frontFooter></frontFooter>
  </div>
</template>

<script type="text/javascript">
import frontFooter from '@c/navigation/frontFooter.vue'
export default {
  components: {
    frontFooter
  },
}
</script>

<style type="text/css" scoped>
.tableBackground {
  width: 100%;
  float: left;
   background-image: url('../../assets/img/images/54.jpg'); 
  background-repeat: no-repeat;
  background-size: cover;
}
.tableBox {
  width: 90%; 
  margin-left: 5%;
  text-align: center;
  /* height: 600px; */
  float: left;
  padding-top: 80px;
  padding-bottom: 80px;
}
.detailBox {
   float: left;
   font-size: 15px;
   color: white;
   /* border: 1px solid white; */
   /* height: 600px; */
   width: 18%;
   margin-left: 2%;
}
.detailBoxTop {
  height: 580px;
  /* border: 1px solid white; */
  background-color: white;
  color: #fe816d;
  box-shadow: 10px 10px 50px rgb(210,60,60);
  /* border-bottom: 1px  solid red; */
  /* text-align: center; */
}
.title {
  padding-top: 15px;
  /* background:#38dba4; */
  background-image: url('../../assets/img/price/11.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  height:150px;
  text-align:center;
  line-height:40px;
  /* width: 50%; */
}
.title1 {
  font-size: 25px;
  font-weight: 100;
  letter-spacing: 5px;
  color: white;
  line-height: 40px;
}
.year {
  color: white;
  font-size: 20px;
}
.title2 {
  font-size: 28px;
  /* font-weight: 700px; */
  font-weight: 900;
  color: white;
}
.title3 {
  color: white;
  font-weight: 100;
}
.title4 {
  color: black;
  font-size: 20px;
}
.title5 {
  color: black;
  font-size: 30px;
  letter-spacing: 5px;
}
.title6 {
    font-size: 28px;
  /* font-weight: 700px; */
  font-weight: 900;
  color: #38dba4;
}
.year2 {
    color: #38dba4;
  font-size: 20px;
}
.selectButton {
  /* margin-left: 10%; */
  width:80%;
  height: 50px;
  border: 1px solid #38dba4;
  background: #38dba4;
  color: white;
  font-size: 20px;
  margin-top: 20px;
  border-radius: 30px;
  padding-left: 20px;
  letter-spacing: 8px;
  font-weight: 100;
  /* box-shadow: 10px 10px 50px rgb(210,60,60); */
}
.selectButton:hover,
.selectButton2:hover {
  border: 1px solid #38dba4;
  color: #fe816d;
}
.selectButton:active,
.selectButton2:active {
  background: #11c181;
}
.selectButton:focus,
.selectButton2:focus {
  border: 1px solid #38dba4;
  color: white;
}
.button_selected {
  background: #34B88B;
  color: #fe816d!important;
  border: 1px solid #38dba4;
}
.line {
  text-align: center;
  border-bottom: 1px solid #fe816d;
  line-height: 40px;
  width: 90%;
}
.Boxline {
  padding: 0px 0px 0px 10%;
}
.card0 {
  float: left;
  width: 100%;
  margin-top: 60px;
  padding-bottom: 80px;
}
.card1 {
  /* margin-top: 120px; */
  background: #d6d6d6;
  /* background: red; */
  width: 74%;
  margin-left: 13%;

  /* height: auto; */
}
.card1 {
  padding-top: 50px;
  margin-top: 20px;
  text-align: center;
  padding-bottom: 50px;
  float: left;
}
.buyMessage {
  padding-top: 30px;
  width: 60%;
  margin-left: 20%;
  height: 180px;
  font-size: 25px;
  background: white;
  box-shadow: 10px 10px 30px rgb(166,166,166);
}
.selectButton2 {
  width: 300px;
  border: 1px solid #38dba4;
  background: #38dba4;
  border-radius: 30px;
  height: 50px;
  font-size: 20px;
  letter-spacing: 8px;
  color: white;
  margin-top: 10px
}
.left {
  width: 40%;
  float: left;
}
.card2 {
  width: 40%;
  float: left;
  padding-right: 100px;
}
.scanMe{
  margin-top: 5px;
  color: black;
  letter-spacing: 2px;
}
.term {
  width: 74%;
  margin-left: 13%;
  margin-top: 550px;
}
ul li {
  list-style-type: none;
}
.buySuccessClass {
  font-size: 30px;
  text-align: center;
}
@media (max-width: 1024px) {
  .detailBoxTop {
    height: 500px;
    font-size: 10px;
  }
  .detailBox {
    font-size: 20px;
  }
  .selectButton2 {
    width: 150px;
  }
}
@media (max-width: 420px) {
  .detailBox {
    width: 80%;
    margin-left: 10%;
  }
  .detailBoxTop {
    /* height: 400px; */
    height: auto;
    font-size: 15px;
  }
  .weixinpaylogo {
    display: none;
  }
  .title {
    margin-top: 10px;
  }
  ul li {
    list-style: none;
  }
  .left {
    width: 100%;
  }
  .selectButton2 {
    width: 200px;
  }
  .card1 {
    margin-left: 0px;
    width: 100%;
  }
  .card2 {
    width: 100%;
    margin: 0px;
    padding: 0px;
    margin-top: 20px;
  }
  .term ul {
    margin-left: -40px;
  }
  .selectButton {
    margin-top: 0px;
    margin-bottom: 50px;
  }
}
</style>

